<template lang="html">
	<section class="tabview-recommend">
	    <div class="recommend" v-if="Array.isArray(crossRecommend) && crossRecommend.length">
	        <div class="journeys-title">
	            产品推荐
	        </div>
	        <div class="list" @scroll.once="eventTrack('SCROLL_INDEX_RECOMMEND')">
	            <ul>
	                <card
	                    :form="form"
	                    :key="i"
	                    v-for="(form, i) in crossRecommend">
	                </card>
	            </ul>
	        </div>
	    </div>
    </section>
</template>

<script>
    import Card from '../recommend/Card.vue';
    import {eventTrack} from '@/business/analy';

    export default {
        name: 'Recommend',
        props: {
            crossRecommend: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },

        computed: {
        },

        components: {
            Card
        },
        methods: {
            eventTrack
        }
    }

</script>

<style lang="scss">
    .tabview-recommend {
        .recommend{
            padding: 0;
        }
        .journeys-title {
            margin-bottom: 20px;
        }
        .recommend-card a {
            background: #f6f6f6;
        }
    }
</style>



// WEBPACK FOOTER //
// Recommend.vue